import { ClerkProvider } from '@clerk/react-router';
import { useLingui } from '@lingui/react/macro';
import { APP_PATHS } from 'app-shared/constants';
import { type ReactNode } from 'react';

import { CLERK_APPEARANCE } from '@/auth/clerk/constants/ClerkAppearance';
import { clerkBaseLocalizationState } from '@/auth/clerk/states/clerkBaseLocalizationState';
import { getClerkLocalization } from '@/auth/clerk/utils/getClerkLocalization';
import { CLERK_PUBLISHABLE_KEY } from '@/auth/constants/ClerkPublishableKey';
import { useAtomStateValue } from '@/ui/utilities/state/jotai/hooks/useAtomStateValue';

type ClerkAppProviderProps = {
  children: ReactNode;
};

// Inside the router: Clerk's screens navigate with React Router. A person
// without a workspace is sent to our onboarding page to create or pick one.
export const ClerkAppProvider = ({ children }: ClerkAppProviderProps) => {
  // Changes with the language, so Clerk's screens switch language too.
  const { i18n } = useLingui();
  const clerkBaseLocalization = useAtomStateValue(clerkBaseLocalizationState);

  return (
    <ClerkProvider
      publishableKey={CLERK_PUBLISHABLE_KEY}
      appearance={CLERK_APPEARANCE}
      localization={getClerkLocalization(clerkBaseLocalization, i18n)}
      signInUrl={APP_PATHS.signIn}
      signUpUrl={APP_PATHS.signUp}
      signInFallbackRedirectUrl={APP_PATHS.home}
      signUpFallbackRedirectUrl={APP_PATHS.home}
      afterSignOutUrl={APP_PATHS.signIn}
      taskUrls={{ 'choose-organization': APP_PATHS.onboardingWorkspace }}
    >
      {children}
    </ClerkProvider>
  );
};
